var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-h4"},[_vm._v("What are your outpulsed digits?")]),_c('v-select',{attrs:{"label":"Outpulsed Digits","value":_vm.currentOPD,"items":_vm.opds},on:{"input":_vm.setOPD}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }